import { StocksDownIcon, StocksUpIcon } from "@hero-app/components/ui/icons/nav-icons";

export function TrendBadge({ value, positive }: { value: string; positive: boolean }) {
  return (
    <span
      className="inline-flex h-[13px] items-center gap-0.5 rounded-full px-[3px] pb-px pr-0.5 text-[8px] leading-none"
      style={{
        background: positive ? "rgba(22, 163, 74, 0.1)" : "rgba(239, 68, 111, 0.1)",
        color: positive ? "#16a34a" : "#ef446f",
      }}
    >
      {value}
      {positive ? (
        <StocksUpIcon className="h-[5px] w-[6px] shrink-0" />
      ) : (
        <StocksDownIcon className="h-[5px] w-[6px] shrink-0" />
      )}
    </span>
  );
}
